'use client';
import { useTheme, useMediaQuery } from '@mui/material';

const useMediaQueries = () => {
    const theme = useTheme();
    return theme.breakpoints.keys
        .reverse()
        .reduce((acc, breakpoint) => (Object.assign(Object.assign({}, acc), { [breakpoint]: useMediaQuery(theme.breakpoints.up(breakpoint)) })), {});
};

export { useMediaQueries };
